import React from "react";
import { useInView, useMotionValue, useSpring } from "framer-motion";

// Splits "Up to 90%" / "₹22 crore" / "$4.44M" into prefix + number + suffix and counts the number up.
const parse = (raw) => {
  const m = String(raw).match(/^(\D*?)([\d.,]+)(.*)$/);
  if (!m) return null;
  const numeric = Number(m[2].replace(/,/g, ""));
  if (!Number.isFinite(numeric)) return null;
  const decimals = (m[2].split(".")[1] || "").length;
  return { prefix: m[1], numeric, decimals, suffix: m[3] };
};

export const Counter = ({ value, className }) => {
  const ref = React.useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const parsed = React.useMemo(() => parse(value), [value]);
  const mv = useMotionValue(0);
  const spring = useSpring(mv, { duration: 1600, bounce: 0 });
  const [shown, setShown] = React.useState(0);

  React.useEffect(() => {
    if (inView && parsed) mv.set(parsed.numeric);
  }, [inView, parsed, mv]);

  React.useEffect(() => spring.on("change", (v) => setShown(v)), [spring]);

  if (!parsed) {
    return (
      <span ref={ref} className={className}>
        {value}
      </span>
    );
  }
  return (
    <span ref={ref} className={className}>
      {parsed.prefix}
      {shown.toLocaleString("en-IN", {
        minimumFractionDigits: parsed.decimals,
        maximumFractionDigits: parsed.decimals,
      })}
      {parsed.suffix}
    </span>
  );
};
